import { http } from '@/core/api/';

const apiUrl = 'api/alternativelocation';

export const buildToNextYear = () => {
  return http.put(`${apiUrl}/buildnextyear`);
};